__turbopack_context__.v({
  "actions": "headerDesktop-module-scss-module__rIaN6q__actions",
  "darkNotification": "headerDesktop-module-scss-module__rIaN6q__darkNotification",
  "headerDesktop": "headerDesktop-module-scss-module__rIaN6q__headerDesktop",
  "hovered": "headerDesktop-module-scss-module__rIaN6q__hovered",
  "lightNotification": "headerDesktop-module-scss-module__rIaN6q__lightNotification",
  "logo": "headerDesktop-module-scss-module__rIaN6q__logo",
  "wrapper": "headerDesktop-module-scss-module__rIaN6q__wrapper",
});
